import { FC } from "react";
import { Link } from "react-router-dom";
import { getProductUrl } from "../../../utils/helpers";

export const ProductLink: FC<{ item: IFurnitureItem }> = ({ item, ...props }) => (
  <Link to={getProductUrl(item)} target="_blank" rel="noopener" {...props} />
);